<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'pro-report-atendimentolps') {
            next({ name: 'promotor-lps-list', replace: true });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'pro-report-atendimentolps') {
            this.$router.push({ name: 'promotor-lps-list' });
        }
    },
};
</script>
